import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./agendasection.css";
import parse from "html-react-parser";

const AgendaSection = ({webpageData}) => {
  // Array of agenda items
  const agendaData = webpageData?.agendaSection || {};

  return (
    <>
    <div className="agenda-section">
    <Container fluid className="ag-section-container">
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={8} xl={6} className="ag-title-col">
          <h3 className="ag-section-title">{parse(agendaData.title || "")}</h3>
        </Col>
      </Row>
      <Row className="justify-content-center">
          <Col xs={11} md={12} lg={12} xl={12} className="ag-content-col">
            <div className="ag-rectangle-container">
              <div className="ag-purple-rectangle">
                <div className="ag-schedule-wrapper">
                  {agendaData.items && agendaData.items.map((item, index) => (
                    <div key={index} className="ag-schedule-item">
                      <p className="ag-time-entry">
                        <span className="ag-time">{item.time}</span>
                        <span className="ag-time-separator"> | </span>
                        <span className="ag-event">
                          {item.event.includes("(") 
                            ? <>{item.event.split("(")[0]}<em>({item.event.split("(")[1]}</em></>
                            : item.event
                          }
                        </span>
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Col>
        </Row>
    </Container>
    </div>
    </>
  );
};

export default AgendaSection;